// import Photo from "../Images/Photo-grid.png"
const Hero = () => {
    return (
      <section className="hero">
        <div className="hero-photo">
          <img src="../react-project1/Images/Photo-grid.png" alt="hero"  className= "hero-image"/>
        </div>
        <h2>Online Experiences </h2>
        <p>
          Join unique interactive activities led by one-of-a-kind hosts—all
          without leaving home.
        </p>
      </section>
    );
}
export default Hero;